var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.categories.length <= 0)?_c('div',[_vm._v("\n    No simulations for this user/app.\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }